import { useQuery } from '@tanstack/react-query';
import { apiQueryKey, useApiClient } from '@ooh/screens';
import { publicOfferLink } from '@ooh/contracts';

/**
 * Anonymous unit detail — GET /public/offers/:token/units/:unitId, through the ApiClient
 * plug's `callPublic` so no session is sent.
 *
 * Traceability: client-media-unit-detail / Public client media-unit detail route.
 */
export function usePublicUnitDetail(token: string, unitId: string) {
  const api = useApiClient();
  const request = { token, unitId: Number(unitId) };
  return useQuery({
    queryKey: apiQueryKey(publicOfferLink.publicUnitDetail, request),
    queryFn: ({ signal }) => api.callPublic(publicOfferLink.publicUnitDetail, request, { signal }),
  });
}
